import type { SocialsElements } from '@/_types/Shared/Footer';

export default function Socials({ socials }: { socials: SocialsElements[] | undefined }) {
	console.log(socials);
	return (
		<div className='mt-5 flex justify-start gap-5'>
			{socials && socials.length > 0 && (
				<>
					{socials.map((social: SocialsElements, j: number) => (
						<a
							key={j}
							href={social?.url}
							className='text-minos-footer-icon'
							target='_blank'
							rel='noreferrer'
						>
							{social?.icon && (
								<>
									{social?.icon.startsWith('bi-') ? (
										<i className={'text-2xl ' + social?.icon}></i>
									) : (
										<i className={'text-2xl uil uil-' + social?.icon}></i>
									)}
								</>
							)}
						</a>
					))}
				</>
			)}
		</div>
	);
}
